export default __webpack_public_path__ + "static/media/fruit18.2a59df09.jpg";